export const conditionsMap = {
  'true-true-true': 'optedBothIssueHappeningNow',
  'true-true-false': 'optedBothIssueNotHappeningNow',
  'false-false-false': 'noToBothIssueNotHappeningNow',
  'false-false-true': 'noToBothIssueHappeningNow',
  'true-false-true': 'yesEmailNoContactIssueHappeningNow',
  'false-true-true': 'noEmailYesContactIssueHappeningNow',
  'false-true-false': 'noEmailYesContactIssueNotHappeningNow',
  'true-false-false': 'yesEmailNoContactIssueNotHappeningNow',
};
const CONFIRMATION_TEXT =
  'A confirmation email will be sent to the email provided shortly.';
const CONFIRMATION_AND_PHONE =
  'A confirmation email will be sent to the email provided shortly. We may contact you by phone if we need more information.';
const BANK_HOLIDAY_CONTENT =
  'We aim to review your issue within {reviewTime} (Monday to Friday, excluding Bank Holidays). Resolving the issue can take longer.';
const NO_CONTACT =
  'As you did not leave your contact details you will not receive a confirmation email. You won’t be contacted further about the issue.';
const NO_EMAIL_AND_PHONE =
  'You will not receive a confirmation email of your report. We may contact you by phone if we need more information.';

export const contents = {
  optedBothIssueHappeningNow: [CONFIRMATION_AND_PHONE, BANK_HOLIDAY_CONTENT],
  optedBothIssueNotHappeningNow: [CONFIRMATION_AND_PHONE, BANK_HOLIDAY_CONTENT],
  noToBothIssueNotHappeningNow: [NO_CONTACT, BANK_HOLIDAY_CONTENT],
  noToBothIssueHappeningNow: [NO_CONTACT, BANK_HOLIDAY_CONTENT],
  yesEmailNoContactIssueHappeningNow: [CONFIRMATION_TEXT, BANK_HOLIDAY_CONTENT],
  noEmailYesContactIssueHappeningNow: [
    NO_EMAIL_AND_PHONE,
    BANK_HOLIDAY_CONTENT,
  ],
  noEmailYesContactIssueNotHappeningNow: [
    NO_EMAIL_AND_PHONE,
    BANK_HOLIDAY_CONTENT,
  ],
  yesEmailNoContactIssueNotHappeningNow: [
    CONFIRMATION_TEXT,
    BANK_HOLIDAY_CONTENT,
  ],
};
